export default __webpack_public_path__ + "static/media/Neophyte's Girdle of the Emperor's Favor.a17edabe.jpg";